import { useState } from "react";
import { useAppDispatch, useAppState } from "../Store";
import * as config from './config';
import client from './client';
import * as LoginActions from './Actions/Login';
import * as ContactsActions from './Actions/Contacts';
import * as TagsActions from './Actions/Tags';
import * as AutomatisationActions from './Actions/Automatisation';
import * as CustomFieldsActions from './Actions/CustomFields';
import * as ReportsActions from './Actions/Reports';
import * as AppActions from './Actions/App';
import * as ScheduledTaskActions from './Actions/ScheduledTask';
import * as AdminActions from './Actions/Admin';
export const useAPI = () => {
    
    return {
        ...LoginActions,
        ...ContactsActions,
        ...TagsActions,
        ...AutomatisationActions,
        ...CustomFieldsActions,
        ...ReportsActions,
        ...AppActions,
        ...ScheduledTaskActions,
        ...AdminActions
    }
}

// Export API configuration
export const apiConfig = config;

// Export API client
export const apiClient = client;

// Export everything for convenience
export default {
  config,
  client,
  LoginActions
};